import React, { useEffect, useState } from 'react';
import { useShop } from '../../foundation/useShop';
import { loadScript } from '../../utilities';
const URL = 'https://cdn.shopify.com/shopifycloud/shop-js/v0.1/client.js';
/**
 * The `ShopPayButton` component renders a button that redirects to the Shop Pay checkout.
 */
export function ShopPayButton({ variantIds, className }) {
    const [ids, setIds] = useState([]);
    const [shopPayLoaded, setShopPayLoaded] = useState(false);
    const { storeDomain } = useShop();
    useEffect(() => {
        const ids = variantIds.reduce((accumulator, gid) => {
            const id = gid.split('/').pop();
            if (id) {
                accumulator.push(id);
            }
            return accumulator;
        }, []);
        setIds(ids);
    }, [variantIds]);
    useEffect(() => {
        async function loadShopPay() {
            const loaded = await loadScript(URL, {
                module: true,
            });
            if (!loaded) {
                console.warn('shop-pay-button library did not load');
            }
            setShopPayLoaded(true);
        }
        loadShopPay();
    }, []);
    return (React.createElement("div", { className: className, tabIndex: 1 }, shopPayLoaded && (React.createElement("shop-pay-button", { "store-url": `https://${storeDomain}`, variants: ids.join(',') }))));
}
